import { SystemFuncArgs } from '@brochington/ecstatic';
import { getSheetToScreenTransform } from 'editor/utils/transform';
import { Components } from '../components';
import Link from '../components/Link';
import Overlay from '../components/Overlay';

export const renderLinkComponents = [Link];

export function renderLink(args: SystemFuncArgs<Components>): void {
  const { components, world } = args;
  const linkComp = components.get(Link);
  const overlayComp = components.get(Overlay);
  const { ctx } = overlayComp;
  if (!ctx) {
    return;
  }
  const { bbox } = linkComp;
  ctx.save();
  const transform = getSheetToScreenTransform(world);
  ctx.transform(...transform);
  ctx.fillStyle = `rgba(0, 0, 0, 0)`;
  ctx.fillRect(bbox[0], bbox[1], bbox[2] - bbox[0], bbox[3] - bbox[1]);
  ctx.restore();
}
